import _defineProperty from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { prop, merge, mergeAll } from 'ramda';
import { toClientDetailsHeaderWithoutStringify } from '@peloton/analytics';
import { pipeData, toSkipErrorHandlingConfig } from '@peloton/api';
import { toNowTimezoneString } from '@peloton/time';
import { toPeloton } from '@engage/classes';
import { toTimeline } from './mappers';
import { StreamResultKind, toStreamLimitReached, toNoActiveSubscription } from './models';
var CreateStreamErrorCode;

(function (CreateStreamErrorCode) {
  CreateStreamErrorCode[CreateStreamErrorCode["NoActiveSubscription"] = 3031] = "NoActiveSubscription";
  CreateStreamErrorCode[CreateStreamErrorCode["StreamLimitReached"] = 3032] = "StreamLimitReached";
})(CreateStreamErrorCode || (CreateStreamErrorCode = {}));

export var createStream = function createStream(api, classId, contentType) {
  return api.post("/api/ride/".concat(classId, "/stream?content_type=").concat(contentType), {}, toSkipErrorHandlingConfig()).then(pipeData(merge({
    kind: StreamResultKind.VideoStream
  }))).catch(function (err) {
    var code = err.responseBody ? err.responseBody.errorCode : err.response.data.errorCode;

    switch (code) {
      case CreateStreamErrorCode.StreamLimitReached:
        return toStreamLimitReached();

      case CreateStreamErrorCode.NoActiveSubscription:
        return toNoActiveSubscription();

      default:
        throw err;
    }
  });
};

var toStreamHistoryUrl = function toStreamHistoryUrl(streamHistoryId) {
  return "api/stream_history/".concat(streamHistoryId);
};

export var destroyStream = function destroyStream(api, streamHistoryId) {
  return api.delete(toStreamHistoryUrl(streamHistoryId), toSkipErrorHandlingConfig());
};
export var heartbeatStream = function heartbeatStream(api, streamHistoryId) {
  return api.post("".concat(toStreamHistoryUrl(streamHistoryId), "/heartbeat"), {}, toSkipErrorHandlingConfig());
};
var CREATE_PELOTON_URL = '/api/peloton';
export var createPeloton = function createPeloton(api, classId) {
  return api.post(CREATE_PELOTON_URL, {
    rideId: classId
  }).then(pipeData(toPeloton));
};
var CREATE_WORKOUT_URL = '/api/workout';
export var createWorkout = function createWorkout(api, param) {
  var data = {
    pelotonId: param.pelotonId,
    rideId: param.classId,
    subscriptionId: param.subscriptionId,
    streamSubscriptionId: param.subscriptionId,
    streamSubscriptionIdType: param.subscriptionType,
    deviceType: param.deviceType,
    deviceLanguage: param.deviceLanguage,
    workoutType: 'class',
    isDigital: param.isDigital,
    bikeNumber: param.bikeNumber
  };

  var config = _objectSpread({
    headers: mergeAll([{
      'Peloton-Client-Date': toNowTimezoneString()
    }, toClientDetailsHeaderWithoutStringify(param.analyticsProps).headers, {
      'Accept-Language': param.deviceLanguage
    }])
  }, toSkipErrorHandlingConfig());

  return api.post(CREATE_WORKOUT_URL, data, config).then(pipeData(prop('id')));
};

var toLoadTimeline = function toLoadTimeline(id) {
  return "/api/ride/".concat(id, "/timeline");
};

export var fetchClassTimeline = function fetchClassTimeline(api, id) {
  return api.get(toLoadTimeline(id)).then(pipeData(toTimeline));
};

var toEndWorkoutUrl = function toEndWorkoutUrl(workoutId) {
  return "api/workout/".concat(workoutId, "/end");
};

export var endWorkout = function endWorkout(api, workoutId) {
  return api.post(toEndWorkoutUrl(workoutId));
};

var toSendPacketsUrl = function toSendPacketsUrl(workoutId) {
  return "/stats/workout/".concat(workoutId, "/packets");
};

var toSendPacketUrl = 'stats/packet'; // TODO: Have Callisto move to pluralized

export var toSendPackets = function toSendPackets(api, workoutId, packet) {
  var data = {
    packets: [packet]
  };
  api.post(toSendPacketsUrl(workoutId), data);
};
export var sendStatPackets = function sendStatPackets(api, workoutId, packets) {
  return api.post(toSendPacketsUrl(workoutId), {
    packets: packets
  }, toSkipErrorHandlingConfig());
}; // Use this single packet endpoint instead of the batch packet endpoint if you want to show up in leader board rankings

export var sendStatPacket = function sendStatPacket(api, packet) {
  api.post(toSendPacketUrl, packet);
};
var metricsV2Url = '/api/metrics/v2/video';
export var reportMetricsV2 = function reportMetricsV2(api, metrics) {
  return api.post(metricsV2Url, metrics, toSkipErrorHandlingConfig());
};